<div>
    <div class="playlists_title">
<!--        <span class="material-symbols-outlined">subject</span>&nbsp;-->
        All playlists</div>
    <ng-container *ngIf="(dataSourcePlayListState$ | async) as state">
        <div class="video-group">
            <div *ngFor="let playList of state.playLists"
            >
                <div class="video-group-list">
                    <div class="video-group-list-cover" [routerLink]="['/channels/channel-playlist/1/playList',playList.id]">
                        <img class="images-cover-create c1"
                             *ngIf="playList?.videos[0]"
                             [src]="playList?.videos[0]?.thumbnail|getImgPath:'images'"
                             alt="">

                        <img class="images-cover-create c1"
                             *ngIf="!playList?.videos[0]"
                             src="assets/img/playList.png"
                             alt="">
                    </div>
                    <p class="playlist-name">Playlist {{playList.name}}</p>
                </div>
            </div>
        </div>
    </ng-container>
</div>
